import { render, staticRenderFns } from "./EditLanguagesModal.vue?vue&type=template&id=371fc130&"
import script from "./EditLanguagesModal.vue?vue&type=script&lang=js&"
export * from "./EditLanguagesModal.vue?vue&type=script&lang=js&"
import style0 from "./EditLanguagesModal.vue?vue&type=style&index=0&id=371fc130&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports